export default {
  EmailTitle: 'To reset your password, please enter your email.',
  ResetOptionsTitle: 'How would you like to verify your account?',
  SecurityQuestionsTitle: 'Please answer your security questions.',
  ResetTitle: 'Please enter a new password.',
  ResetDescription: 'Passwords must be at least fifteen characters.',
  Success: `Success!`,
  PasswordHasBeenReset: `Your password has been reset.`,
};
